/** @jsx jsx */
import React, { ReactNode, MouseEvent } from "react";
import { jsx } from "@emotion/core";
// eslint-disable-next-line no-unused-vars
import { Wrap } from "./style";

interface DoneCheckboxProps {
  checked?: boolean;
  children?: ReactNode;
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
  disabled?: boolean;
  color?: string;
  background?: boolean;
  title?: string;
  childrenStyles?: React.CSSProperties;
  validate?: boolean;
}

const DoneCheckbox = ({
  checked,
  children,
  onClick,
  disabled,
  color,
  background,
  title,
  childrenStyles,
  validate,
  ...props
}: DoneCheckboxProps) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (!disabled) onClick(event);
  };

  return (
    <Wrap
      onClick={handleClick}
      data-testid="done-checkbox"
      // @ts-ignore
      background={background}
      checked={checked}
      disabled={disabled}
      color={color}
      role="checkbox"
      aria-label={title}
      validate={validate}
      {...props}
    >
      <svg width="16px" height="16px" viewBox="0 0 448 512">
        {checked ? (
          <path
            data-testid="check-square"
            d="M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
          />
        ) : (
          <path
            data-testid="square"
            d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
          />
        )}
      </svg>
      {children && (
        // @ts-ignore
        <div className="nix-margin-left_10" css={childrenStyles}>
          {children}
        </div>
      )}
    </Wrap>
  );
};

export default DoneCheckbox;
